import { startErrorReporting } from './errorReporting';

export const errorReporter = startErrorReporting();
